(function(){
  var t=document.querySelector('.menu-toggle'),m=document.getElementById('mobile-nav');
  if(t&&m){t.addEventListener('click',function(){var o=m.classList.toggle('open');t.setAttribute('aria-expanded',o);});}
  // UGC cards: play Shopify-hosted video or an embed URL on click
  document.querySelectorAll('.vcard').forEach(function(c){
    function load(){
      if(c.dataset.loaded)return;
      var tpl=c.querySelector('template');
      if(tpl){c.appendChild(tpl.content.cloneNode(true));c.dataset.loaded=1;var v=c.querySelector('video');if(v)v.play();}
      else if(c.dataset.embed){c.insertAdjacentHTML('beforeend','<iframe src="'+c.dataset.embed+'" allow="autoplay; encrypted-media" allowfullscreen></iframe>');c.dataset.loaded=1;}
    }
    c.addEventListener('click',load);
    c.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();load();}});
  });
})();
